import { render } from "./Home.vue?vue&type=template&id=68f23e35&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=68f23e35&lang=scss&scoped=true"

import exportComponent from "C:\\htdocs\\sputnik\\vue\\verdura-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f23e35"]])

export default __exports__